import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { getAllCumulativeReport } from "../../../Apis/TrafficMarshalReports/ReportsTrafficMarshal";
import Loader from "../../../Common/Loader/loader";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import isGHMC from "../../../Common/helper/helpar";
const CumulativeOperationReport = ({ t }) => {
  const processTypes = ["Weighbridge", "Unloading", "Fuel Station", "Water Wash", "Maintenance"];
  const headers = [
    { label: "VehicleNo", key: "vehicleNo" },
    { label: "Location of TS/SCTP", key: "locationofTSSCTP" },
    { label: "Vehicle Type", key: "vehicleType" },
    { label: "Equipment Type", key: "equipmentType" },
    { label: "Process Type", key: "processType" },
    { label: "Trip No", key: "tripNo" },
    { label: "In Time", key: "inTime" },
    { label: "Out Time", key: "outTime" },
    { label: "Total Time In Minutes", key: "totalTimeinMinutes" },

  ];

  const [getAllTripsTonnage, setAllTripsTonnage] = useState([]);
  const [startDate, setStartDate] = useState(getStartOfCurrentDate());
  const [data, setData] = useState([]);
  const [endDate, setEndDate] = useState(getCurrentDateTime());
  const [currentPage, setCurrentPage] = useState(1);
  const [vehicleNumber, setVehicleNumber] = useState('');
  const [totalPagesCount, setTotalPagesCount] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const isProd = isGHMC();
  useEffect(() => {
    const currentDate = new Date().toISOString();
    fetchTripsTonnageData(currentDate, currentDate);
  }, []);


  // const fetchTripsTonnageData = async (startDate, endDate) => {
  //   try {
  //     setIsLoading(true);
  //     const requestData = {
  //       FromDateTime: startDate,
  //       ToDateTime: endDate,
  //     };
  //     console.log(requestData,requestData)
  //     const response = await getAllCumulativeReport(requestData);
  //     console.log(response ,'apiresponse')
  //     let formattedData = response.data.map((item) => ({
  //       ...item,
  //       vehicleNo: item.vehicleNo,
  //       locationofTSSCTP: item.locationofTSSCTP,
  //       vehicleType: item.vehicleType,
  //       equipmentType: item.equipmentType,
  //       processType:item.processType,
  //       tripNo:item.tripNo,
  //       inTime:item.inTime,
  //       outTime:item.outTime,
  //       totalTimeinMinutes:item.totalTimeinMinutes 
  //     }));
  //     if (vehicleNumber) {
  //       formattedData = formattedData.filter(item => item.vehicleNo.includes(vehicleNumber));
  //     }
  //     console.log('Filtered Data:', formattedData);
  //     setData(formattedData);
  //     setIsLoading(false);
  //   } catch (error) {
  //     console.error(error);
  //     setIsLoading(false);
  //   }
  // };

  const fetchTripsTonnageData = async (startDate, endDate) => {
    try {
      setIsLoading(true);
      const requestData = {
        FromDateTime: startDate,
        ToDateTime: endDate,
      };

      const response = await getAllCumulativeReport(requestData);
      let formattedData = processResponseData(response.data);
      if (vehicleNumber) {
        formattedData = formattedData.filter(item => item.vehicleNo.includes(vehicleNumber));
      }

      setData(formattedData);
      console.log(formattedData, 'formattedDataaaaaaaaaaaaaaaaa')
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  const processResponseData = (responseData) => {
    const vehiclesMap = {};

    // Initialize vehiclesMap with arrays for each vehicleNo and each processType
    responseData.forEach(item => {
      if (!vehiclesMap[item.vehicleNo]) {
        vehiclesMap[item.vehicleNo] = {};
        processTypes.forEach(processType => {
          vehiclesMap[item.vehicleNo][processType] = [];
        });
      }

      if (!vehiclesMap[item.vehicleNo][item.processType]) {
        vehiclesMap[item.vehicleNo][item.processType] = [];
      }

      vehiclesMap[item.vehicleNo][item.processType].push({
        ...item,
        vehicleNo: item.vehicleNo,
        locationofTSSCTP: item.locationofTSSCTP,
        vehicleType: item.vehicleType,
        equipmentType: item.equipmentType,
        tripNo: item.tripNo,
        inTime: item.inTime,
        outTime: item.outTime,
        totalTimeinMinutes: item.totalTimeinMinutes,
      });
    });

    let processedData = [];

    for (const vehicleNo in vehiclesMap) {
      const vehicleData = vehiclesMap[vehicleNo];

      processTypes.forEach(processType => {
        const processEntries = vehicleData[processType];

        if (processEntries && processEntries.length > 0) {
          processEntries.forEach(entry => {
            processedData.push(entry);
          });
        } else {
          // If no entries for the current processType, push an empty entry
          processedData.push({
            vehicleNo,
            locationofTSSCTP: '',
            vehicleType: '',
            equipmentType: '',
            processType,
            tripNo: '',
            inTime: '',
            outTime: '',
            totalTimeinMinutes: 0,
            style: { backgroundColor: '#E0E0E0' } // Optionally set a different background color for empty entries
          });
        }
      });

      // Calculate total time for all process types combined
      const totalTime = Object.values(vehicleData).reduce((total, entries) => {
        return total + (entries.reduce((subTotal, entry) => subTotal + (entry.totalTimeinMinutes || 0), 0));
      }, 0);

      processedData.push({
        vehicleNo,
        locationofTSSCTP: '',
        vehicleType: '',
        equipmentType: '',
        processType: 'Total',
        tripNo: '',
        inTime: '',
        outTime: '',
        totalTimeinMinutes: totalTime,
        style: { backgroundColor: '#443D3D' }
      });
    }

    return processedData;
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const currentDate = new Date().toISOString();
    const FromDateTime = startDate || currentDate;
    const ToDateTime = endDate || currentDate;
    fetchTripsTonnageData(FromDateTime, ToDateTime);
  };


  const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
  const generationTime = ` ${new Date().toLocaleString('en-GB', options).replace(/\//g, '/')}`;
  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1
      }-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `Primary Deployment Transaction Reports`;
    const downloadDateTime = `Report on: ${generationTime},${formattedTime}`;
    // Calculate the length of the downloadDateTime string
    const downloadDateTimeLength = downloadDateTime.length;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");
    // Define styles
    const boldFont = { bold: true };

    // Add the downloadDateTime to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", downloadDateTime, ""]); // Update array length to match new cell range
    worksheet.mergeCells(1, 2, 1, 11); // Merge cells for downloadDateTime from column 2 to 4
    worksheet.getCell(1, 2).value = downloadDateTime; // Ensure the value is set after merging
    worksheet.getCell(1, 2).font = boldFont; // Set font style
    worksheet.getCell(1, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B1, C1, D1)
    for (let col = 2; col <= 11; col++) {
      worksheet.getCell(1, col).font = boldFont; // Set styles individually
      worksheet.getCell(1, col).alignment = { horizontal: "center" }; // Center align the cell content
    }

    // Add "Zone Details" to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", "Primary Deployment Transaction Reports", ""]); // Update array length to match new cell range
    worksheet.mergeCells(2, 2, 2, 11); // Merge cells for Zone Details from column 2 to 4
    worksheet.getCell(2, 2).value = "Primary Deployment Transaction Reports"; // Ensure the value is set after merging
    worksheet.getCell(2, 2).font = boldFont; // Set font style
    worksheet.getCell(2, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B2, C2, D2)
    for (let col = 2; col <= 11; col++) {
      worksheet.getCell(2, col).font = boldFont; // Set styles individually
      worksheet.getCell(2, col).alignment = { horizontal: "center" }; // Center align the cell content
    }



    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Vehicle UID",
      "Vehicle Number",
      "Zone",
      "Circle",
      "Ward",
      "PD Incharge",
      "Driver Name",
      "Deployment Date",
      "Latitude",
      "Longitude"
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" }; // Left align the cell content
      if (colNumber >= 1 && colNumber <= 11) {
        // Apply background color only to specific cells
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" } // Red background color
        };
      }
    });

    // Add data rows
    data.forEach((item, index) => {
      worksheet.addRow([
        index + 1,
        item.vehicleUuid?? "N/A",
        item.vehicleNumber?? "N/A",
        item.zone?? "N/A",
        item.circle?? "N/A",
        item.ward?? "N/A",
        item.pdIncharge?? "N/A",
        item.driverName?? "N/A",
        item.deploymentDate?? "N/A",
        item.latitude?? "N/A",
        item.longitude?? "N/A"
      ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber >= 1 && colNumber <= 11) {
          // Align the columns from 1 to 4 to the left
          cell.alignment = { horizontal: "left" };
        } else {
          // Align the rest of the columns to the center
          cell.alignment = { horizontal: "center" };
        }
      });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "primaryDeploymentTransactionReports.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  const handlePageChange = (page) => {
    const newPage = Math.max(1, Math.min(page, totalPagesCount));
    setCurrentPage(newPage);
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div style={{ width: "100%" }}>
          <div className="content">
            <div className="page-content">
              <h4 className="text-start mb-3">
                Cumulative Operation Report For The Individual Report
              </h4>
              <div className="card">
                <div className="card-body p-3">
                  <div className="row align-items-end">
                    <div className="col-md-10">
                      <form onSubmit={handleFormSubmit}>
                        <div className="row align-items-end" style={{ textAlign: "left" }}>
                          <div className="col-md-3 ">
                            <label>From Date & Time:</label>
                            <input
                              type="datetime-local"
                              name="FromDate"
                              style={inputStyle}
                              className="form-control"
                              value={startDate}
                              max={getCurrentDateTime()}
                              onChange={(e) => setStartDate(e.target.value)}
                            />
                          </div>
                          <div className="col-md-3">
                            <label>To Date & Time:</label>
                            <input
                              type="datetime-local"
                              name="ToDate"
                              style={inputStyle}
                              value={endDate}
                              className="form-control"
                              max={getCurrentDateTime()}
                              onChange={(e) => setEndDate(e.target.value)}
                            />
                          </div>
                          <div className="col-md-2">
                            <label className="form-label">Vehicle Number
                            </label>
                            <input
                              type="text"
                              name="vehicleTypeCode"
                              style={inputStyle}
                              placeholder="Vehicel Number"
                              value={vehicleNumber}
                              onChange={(e) => setVehicleNumber(e.target.value)}
                            />
                          </div>
                          <div className="col-md-2">
                            <button
                              type="submit"
                              className={`btn ${isProd ? "search-ghmc" : "search-swm"}`}
                            >
                              Search
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                    <div className="col-md-2">
                      <button
                        className="btn btn-excel ms-auto mt-4"
                        onClick={downloadAsExcel}
                      >
                        <i className="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                      </button>
                    </div>
                  </div>
                  <div className="mt-3">
                    <div
                      style={{ height: "100%", boxSizing: "content-box" }}
                      onWheel={(e) => {
                        const container = e.currentTarget;
                        container.scrollTop += e.deltaY;
                      }}
                    >
                      <div className="table-container">
                        <table
                          id="project-reports"
                          style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            marginBottom: "10px",
                          }}
                          className="table table-bordered table-hover text-center"
                        >
                          <thead>
                            <tr>
                              <th
                                style={{
                                  border: "1px solid #ddd",
                                  textAlign: "justify",
                                  backgroundColor: "#EC1117",
                                  width: "15px",
                                }}
                              >
                                {t("S.No")}
                              </th>
                              {headers.map((header, index) => (
                                <th
                                  key={index}
                                  style={{
                                    border: "1px solid #ddd",
                                    textAlign: "justify",
                                    backgroundColor: "#EC1117",
                                  }}
                                >
                                  {t(header.label)}
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {data.length > 0 ? (
                              data.map((item, index) => (
                                <tr key={index} className={index % 2 === 0 ? 'table-row-even' : 'table-row-odd'}>
                                  <td
                                    style={{
                                      border: "1px solid #FFFFFF",
                                      paddingLeft: "25px",
                                      textAlign: "justify",
                                      backgroundColor:
                                        item.processType == 'Total' ? '#443D3D' : (index % 2 === 0
                                          ? "#F8CCCD"
                                          : "#FBE6E8"),
                                    }}
                                  >
                                    {index + 1}
                                  </td>
                                  {headers.map((header, idx) => (
                                    <td
                                      key={idx}
                                      style={{
                                        border: "1px solid #FFFFFF",
                                        textAlign: "justify",
                                        backgroundColor:
                                          item.processType == 'Total' ? '#443D3D' : (index % 2 === 0
                                            ? "#F8CCCD"
                                            : "#FBE6E8"),
                                      }}

                                      className={(header.key == 'totalTimeinMinutes' && item.processType == 'Total' ? 'text-white' : '')}
                                    >
                                      {item.processType == 'Total' ? (header.key == 'totalTimeinMinutes' ? item[header.key] : '') : item[header.key]}

                                    </td>
                                  ))}
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  colSpan={headers.length + 1}
                                  style={{ textAlign: "center" }}
                                >
                                  {t("No data available")}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                      <div
                        style={{
                          marginTop: "10px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "end",
                          padding: "8px",
                        }}
                      >
                        <span>
                          Page {currentPage} of {totalPagesCount}
                        </span>
                        <button
                          style={{
                            backgroundColor: "#EC1117",
                            color: "#fff",
                            borderRadius: "4px",
                            border: "none",
                            padding: "8px 12px",
                            marginLeft: "20px",
                            marginRight: "20px",
                            cursor: "pointer",
                          }}
                          onClick={() => handlePageChange(currentPage - 1)}
                          disabled={currentPage === 1}
                        >
                          Previous
                        </button>
                        <button
                          style={{
                            backgroundColor: "#EC1117",
                            color: "#fff",
                            borderRadius: "4px",
                            border: "none",
                            padding: "8px 12px",
                            cursor: "pointer",
                          }}
                          onClick={() => handlePageChange(currentPage + 1)}
                          disabled={currentPage === totalPagesCount}
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const inputStyle = {
  height: "38px",
  borderRadius: "4px",
  border: "1px solid #ced4da",
  paddingLeft: "10px",
  width: "100%",
};

const buttonStyle = {
  height: "38px",
  width: "100%",
};

export default withTranslation()(CumulativeOperationReport);

const getStartOfCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00`;
};

// Function to get current date and time in the required format
const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours()).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hour}:${minute}`;
};

